import { SortParams } from '../../../typings/grid';
import { Marketer } from '../../../typings/marketers';

export const UPDATE_INTERNAL_MARKETER = 'UPDATE_INTERNAL_MARKETER';
export type UPDATE_INTERNAL_MARKETER = typeof UPDATE_INTERNAL_MARKETER;

export interface UpdateInternalMarketer {
    type: UPDATE_INTERNAL_MARKETER;
    marketer: Marketer;
    productsSortParams?: SortParams;
}

export function updateInternalMarketerAction(
    marketer: Marketer,
    productsSortParams?: SortParams
): UpdateInternalMarketer {
    return {
        type: UPDATE_INTERNAL_MARKETER,
        marketer,
        productsSortParams
    };
}
